import { getSettingsState } from '@containers/settings/settings.selectors'
import { Map } from 'immutable'
import { getCreatePropertyState } from './../properties.selectors'
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'
import {
  SetDefaultData,
  UpdateField,
  CreatePropertyRequest,
} from './../properties.actions'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Store, select } from '@ngrx/store'
import FormTrait from '@traits/form.trait'
import { Subscription } from 'rxjs'
import Validator from '@shared/validatorjs/src/validator'

@Component({
  selector: 'app-create-property',
  templateUrl: './create-property.component.html',
  styleUrls: ['./create-property.component.css'],
})
export class CreatePropertyComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  private parent: string
  private tab: string
  private state$: Subscription
  public routerEvents$: Subscription
  private settings$: Subscription
  private minLat: number
  private maxLat: number
  private minLng: number
  private maxLng: number

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createProperty'))
    const urlSegments = this.router.url.split('/')
    this.tab = urlSegments[urlSegments.length - 1]
    this.parent = 'createProperty'

    const getState = getCreatePropertyState
    this.state$ = this.store.pipe(select(getState)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')
    })

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        const settings = state.get('data')
        const gisExtent = settings.get('gisExtent')

        if (gisExtent) {
          const coordinates = gisExtent
            .split(',')
            .map((c: string) => parseFloat(c))

          this.minLat = coordinates[1]
          this.maxLat = coordinates[3]
          this.minLng = coordinates[0]
          this.maxLng = coordinates[2]
        }
      })

    this.routerEvents$ = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        const urlSegments = e.url.split('/')
        this.tab = urlSegments[urlSegments.length - 1]
      }
    })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.routerEvents$.unsubscribe()
    this.settings$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name
          ? e
          : e.target.type === 'checkbox'
          ? e.target.checked
          : e.target.value,
        `${this.parent}.data`,
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        this.parent,
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const commonRules: any = {}
    const rules = {
      details: {
        // numberOfStories: 'numeric|required|min:0'
      },
      measure: {
        'building.pointLat': `required|numeric`,
        'building.pointLng': `required|numeric`,
        // 'building.pointLat': `required|min:${this.minLat}|max:${this.maxLat}|numeric`,
        // 'building.pointLng': `required|min:${this.minLng}|max:${this.maxLng}|numeric`,
      },
      contacts: {
        'contacts.*.business.businessProportion': 'numeric|min:0',
      },
      gallery: {},
      features: {},
      documents: {},
    }

    // if (this.tab === 'measure') {
    //   rules['building.area'] = 'numeric|required'
    // }

    const validator = new Validator(data.toJS(), {
      ...commonRules,
      ...rules[this.tab],
    })
    validator.setAttributeNames({
      'building.area': 'Roof top area',
      'building.pointLat': 'Latitude',
      'building.pointLng': 'Longitude',
    })

    return validator
  }

  public save(): void {
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreatePropertyRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          this.parent,
        ),
      )
    }
  }

  public tabChanged(tab: Array<string>) {
    const validation = this.validation()

    if (validation.passes()) {
      this.router.navigate(['properties', 'create', ...tab])
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          this.parent,
        ),
      )
    }
  }
}
